import { useContext } from 'react';
import OrderPageStoreContext from './OrderPageStoreContext';
import type OrderPageStore from './orderPageStore';

export const useOrderPageStore = (): OrderPageStore => useContext(OrderPageStoreContext);
